//For fast bundle code

document.addEventListener("DOMContentLoaded", function() {
  function openAllAccordions() {
    const allPanels = document.querySelectorAll('[class^="Accordion_panel"]');
    const allHeads = document.querySelectorAll('[class^="Accordion_head"]');
    const allArrows = document.querySelectorAll('[class^="Accordion_arrow"]');

    if (allPanels.length > 0) {
      allPanels.forEach(panel => {
        panel.classList.add("rb_active");
        panel.style.display = "block";
        panel.style.maxHeight = "unset";
      });

      allHeads.forEach(head => {
        head.classList.add("rb_active");
      });

      allArrows.forEach(arrow => {
        arrow.classList.add("rb_active");
      });
      return true;
    }
    return false;
  }
  if (!openAllAccordions()) {
    const observer = new MutationObserver(() => {
      if (openAllAccordions()) {
        observer.disconnect(); 
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
});



(function () {
  'use strict';

  function hydrateVideo(video) {
    if (!video) return;

    // force copy all <source data-src> to src
    video.querySelectorAll('source[data-src]').forEach(source => {
      const newSrc = source.dataset.src;
      if (newSrc && source.getAttribute('src') !== newSrc) {
        source.setAttribute('src', newSrc);
      }
    });

    // reload the video after swapping sources
    try { video.load(); } catch (e) {}

    // autoplay if flagged
    if (
      video.hasAttribute('autoplay') ||
      video.hasAttribute('data-video-autoplay') ||
      video.dataset.videoAutoplay === 'true'
    ) {
      video.muted = true;
      video.playsInline = true;
      const p = video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    }

    // mark as hydrated for later, but don’t skip if already had data-hydrated
    video.dataset.hydrated = '1';
  }

  function primeExisting() {
    document.querySelectorAll('video[data-video-type="native"]').forEach(hydrateVideo);
  }

  // mutation observer to hydrate new videos added later
  const observer = new MutationObserver(mutations => {
    mutations.forEach(m => {
      if (m.addedNodes && m.addedNodes.length) {
        m.addedNodes.forEach(node => {
          if (!(node instanceof HTMLElement)) return;
          if (node.matches && node.matches('video[data-video-type="native"]')) {
            hydrateVideo(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('video[data-video-type="native"]').forEach(hydrateVideo);
          }
        });
      }
    });
  });

  function startAll() {
    primeExisting();
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  // trigger once on first mouse move or touch
  window.addEventListener('mousemove', startAll, { once: true, passive: true });
  window.addEventListener('touchstart', startAll, { once: true, passive: true });
})();






document.addEventListener("DOMContentLoaded", function () {

  const swatches = document.querySelectorAll("label.variant-swatch");
  const mediaItems = document.querySelectorAll(".itg_ctm_variant_img");
  const targetWrapper = document.querySelector(".itg_product_img_update");

  if (!targetWrapper) return;

  swatches.forEach((swatch) => {
    swatch.addEventListener("click", function () {

      const selectedVariant = this.getAttribute("data-color");
      if (!selectedVariant) return;

      mediaItems.forEach((media) => {
        const mediaVariant = media.getAttribute("data-variant-name");

        if (
          mediaVariant &&
          mediaVariant.toLowerCase() === selectedVariant.toLowerCase()
        ) {
          targetWrapper.innerHTML = media.innerHTML;
          itgRefreshSwappedSlider(targetWrapper);
        }
      });

    });
  });

});

document.addEventListener("DOMContentLoaded", function () {

  const swatches = document.querySelectorAll("label.variant-swatch");
  const mediaItems = document.querySelectorAll(".itg_ctm_tumbvariant_img");
  const targetWrapper = document.querySelector(".itg_tumb_img_update");

  if (!targetWrapper) return;

  swatches.forEach((swatch) => {
    swatch.addEventListener("click", function () {

      const selectedVariant = this.getAttribute("data-color");
      if (!selectedVariant) return;

      mediaItems.forEach((media) => {
        const mediaVariant = media.getAttribute("data-variant-name");

        if (
          mediaVariant &&
          mediaVariant.toLowerCase() === selectedVariant.toLowerCase()
        ) {
          targetWrapper.innerHTML = media.innerHTML;
          itgRefreshSwappedSlider(targetWrapper);
        }
      });

    });
  });

});



// After the ITG color-swap replaces slider contents via innerHTML, the Swiper
// instance still holds references to the removed slides: sizing, active state
// and the orange thumb highlight all go stale. Strip leftover state classes
// from the swapped-in markup and tell the sliders to re-measure.
function itgRefreshSwappedSlider(wrapper) {
  wrapper.querySelectorAll(".swiper-slide").forEach(function (sl) {
    sl.classList.remove(
      "swiper-slide-active",
      "swiper-slide-next",
      "swiper-slide-prev",
      "swiper-slide-visible",
      "swiper-slide-fully-visible",
      "swiper-slide-thumb-active"
    );
    sl.style.width = "";
  });
  var el = wrapper.closest(".swiper");
  if (el && el.swiper) {
    el.swiper.update();
    el.swiper.slideTo(0, 0);
    if (el.swiper.thumbs && el.swiper.thumbs.swiper) {
      el.swiper.thumbs.swiper.update();
    }
  }
  if (el && el.classList.contains("js-media-sublist")) {
    var firstThumb = wrapper.querySelector(".swiper-slide");
    if (firstThumb) firstThumb.classList.add("swiper-slide-thumb-active");
  }
  if (el && el.classList.contains("js-media-list")) {
    itgPreloadAround(el, 3);
  }
}


// Gallery slides are lazy-loaded (good for page speed), but that means each
// swipe used to wait on a fresh download. Keep the neighboring slides
// downloaded ahead of the user: on idle after load, and again on every touch,
// flip the next few slides' images to eager so swiping is instant.
function itgEagerizeSlide(slide) {
  if (!slide) return;
  slide.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
    img.loading = "eager";
  });
}
function itgPreloadAround(list, count) {
  var act =
    list.querySelector(".swiper-slide-active") ||
    list.querySelector(".swiper-slide");
  if (!act) return;
  itgEagerizeSlide(act.previousElementSibling);
  var n = act;
  for (var i = 0; i < (count || 2); i++) {
    n = n && n.nextElementSibling;
    itgEagerizeSlide(n);
  }
}
document.addEventListener("DOMContentLoaded", function () {
  var run = function () {
    document.querySelectorAll(".js-media-list").forEach(function (l) {
      itgPreloadAround(l, 2);
    });
  };
  if ("requestIdleCallback" in window) requestIdleCallback(run, { timeout: 3000 });
  else setTimeout(run, 1500);
});
["touchstart", "pointerdown"].forEach(function (evt) {
  document.addEventListener(
    evt,
    function (e) {
      var list = e.target && e.target.closest && e.target.closest(".js-media-list");
      if (list) itgPreloadAround(list, 3);
    },
    { passive: true }
  );
});


// --- Sitewide presentation fixes (homepage + header dropdown) ---
(function () {
  var css = [
    /* hide the "N Colours" caption on product cards */
    ".product_color-count{display:none!important}",
    /* Explore All slider: clip the partial 4th card that bled in at the right edge */
    ".itg_featured_collection .mySwiper_2{overflow:hidden!important}",
    /* uniform square media on homepage product grids (fixes odd-height cards like MOD 002) */
    ".itg_product_grid_part .card__media, .itg_product_grid_part .media, .itg_product_grid_part [class*='card'] [class*='media']{aspect-ratio:1/1!important;height:auto!important;padding-top:0!important}",
    ".itg_product_grid_part [class*='media'] img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover}",
    /* header dropdown thumbs: blend their white studio background onto the brand grey gradient */
    ".itg-submenu-img-bg img{mix-blend-mode:multiply;display:block}",
    ".itg-submenu-img-bg{display:inline-block;background-image:linear-gradient(#8a8a8a,#d6d6d6);line-height:0;border-radius:6px;overflow:hidden}"
  ].join("");
  var st = document.createElement("style");
  st.textContent = css;
  document.head.appendChild(st);
  var wrapMenuImages = function () {
    document.querySelectorAll(".header__submenu a > img").forEach(function (img) {
      if (img.closest(".itg-submenu-img-bg")) return;
      var w = document.createElement("span");
      w.className = "itg-submenu-img-bg";
      img.parentNode.insertBefore(w, img);
      w.appendChild(img);
    });
  };
  if (document.readyState !== "loading") wrapMenuImages();
  document.addEventListener("DOMContentLoaded", wrapMenuImages);
})();


// Autoplay videos (hero: 17.5MB, banner: 5MB) were downloading during page
// load, burying mobile. Defer them: posters paint immediately, the hero video
// starts once the page is loaded/idle (or on first interaction), and
// below-fold videos only load when scrolled near. data-src videos are skipped
// (the theme already hydrates those lazily).
(function () {
  var deferVideo = function (v, start) {
    if (v.dataset.itgVideoDeferred) return;
    var sources = Array.prototype.slice
      .call(v.querySelectorAll("source"))
      .filter(function (s) { return s.getAttribute("src"); });
    var attrSrc = v.getAttribute("src");
    if (!sources.length && !attrSrc) return;
    v.dataset.itgVideoDeferred = "1";
    var stash = sources.map(function (s) { return s.getAttribute("src"); });
    sources.forEach(function (s) { s.removeAttribute("src"); });
    if (attrSrc) v.removeAttribute("src");
    try { v.load(); } catch (e) {}
    var restored = false;
    var restore = function () {
      if (restored) return;
      restored = true;
      sources.forEach(function (s, i) { s.setAttribute("src", stash[i]); });
      if (attrSrc) v.setAttribute("src", attrSrc);
      try {
        v.load();
        var pr = v.play();
        if (pr && pr.catch) pr.catch(function () {});
      } catch (e) {}
    };
    start(restore);
  };
  var ric = window.requestIdleCallback || function (f) { setTimeout(f, 2000); };
  var init = function () {
    document.querySelectorAll("video[autoplay]").forEach(function (v) {
      var inFirstView = v.getBoundingClientRect().top < window.innerHeight * 1.2;
      if (inFirstView) {
        deferVideo(v, function (restore) {
          var done = false;
          var go = function () { if (done) return; done = true; restore(); };
          window.addEventListener("load", function () { ric(go, { timeout: 2500 }); }, { once: true });
          setTimeout(go, 6000);
          ["touchstart", "mousemove", "scroll", "keydown"].forEach(function (t) {
            window.addEventListener(t, go, { once: true, passive: true });
          });
        });
      } else {
        deferVideo(v, function (restore) {
          if (!("IntersectionObserver" in window)) { setTimeout(restore, 4000); return; }
          var io = new IntersectionObserver(function (en) {
            if (en[0].isIntersecting) { io.disconnect(); restore(); }
          }, { rootMargin: "100% 0px" });
          io.observe(v);
        });
      }
    });
  };
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
